export type AppConfig = {
    apiPrefix: string
    authenticatedEntryPath: string
    unAuthenticatedEntryPath: string
    tourPath: string
    locale: string
    enableMock: boolean
}

const appConfig: AppConfig = {
    apiPrefix: import.meta.env.VITE_API_KEY || '',
    // apiPrefix: '/api',
    authenticatedEntryPath: '/userDetails',
    unAuthenticatedEntryPath: '/admin',
    tourPath: '/',
    locale: 'en',
    enableMock: true,
}

export default appConfig
